<template>
    <Grid :class="classes" :gap-y="5">
        <Column :span="6">
            <FormField
                v-if="'providers' in schema"
                name="providers"
                :error="error"
                :label="$t('booksBuilds.edit.providerLabel')"
                :required="schema.providers.required"
                label-width="200px"
            >
                <template v-if="schema.providers.multiple">
                    <MultiSelect
                        v-model="values.providers"
                        :options="schema.providers.choises"
                        :disabled="$values.providers.disabled"
                        :form-value-text="({ label }) => label[$i18n.locale]"
                        emit-prop="name"
                        width="100%"
                        placeholder=" "
                    >
                        <template #default="{item}">
                            {{ item.label[$i18n.locale] }}
                        </template>
                    </MultiSelect>
                </template>
                <template v-else>
                    <CustomSelect
                        v-model="values.providers"
                        :options="schema.providers.choises"
                        :disabled="$values.providers.disabled"
                        :form-value-text="({ label }) => label[$i18n.locale]"
                        emit-prop="name"
                        width="100%"
                        placeholder=" "
                    >
                        <template #default="{item}">
                            {{ item.label[$i18n.locale] }}
                        </template>
                    </CustomSelect>
                </template>
            </FormField>
            <div class="build-config__options">
                <FormField name="without_author">
                    <Checkbox v-model="values.without_author">
                        Without author
                    </Checkbox>
                </FormField>
                <FormField name="without_title">
                    <Checkbox v-model="values.without_title">
                        Without title
                    </Checkbox>
                </FormField>
                <FormField name="without_preview">
                    <Checkbox v-model="values.without_preview">
                        Without preview
                    </Checkbox>
                </FormField>
            </div>
        </Column>
        <Column :span="6">
            <FormField
                v-if="'build_types' in schema"
                name="build_types"
                :error="error"
                :label="$t('booksBuilds.edit.typeLabel')"
                :required="schema.build_types.required"
                label-width="200px"
            >
                <MultiSelect
                    v-model="values.build_types"
                    :options="schema.build_types.choises"
                    emit-prop="name"
                    view-label="label"
                    :form-value-text="({ label }) => label"
                    width="100%"
                    placeholder=" "
                    :disabled="$values.build_types.disabled"
                />
            </FormField>
            <FormField
                v-if="'speed' in schema"
                name="speed"
                :label="$t('booksBuilds.edit.speedLabel')"
                :error="error"
                :required="schema.speed.required"
            >
                <NumberInput
                    v-model="values.speed"
                    :step="0.05"
                    :min="0.8"
                    :max="1.4"
                    :disabled="$values.speed.disabled"
                    with-input
                />
            </FormField>
        </Column>
        <button
            v-if="canDelete"
            class="button button--blank build-config__delete"
            @click.prevent="deleteConfig"
        >
            <IconCross />
        </button>
    </Grid>
</template>
<script>
import {
    CustomSelect,
    MultiSelect,
    FormField,
    NumberInput,
    Checkbox
} from '@speechki-frontend/shared/ui/forms';

import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';
export default {
    name: 'BuildConfig',
    components: {
        CustomSelect,
        MultiSelect,
        FormField,
        NumberInput,
        Checkbox,
        Grid,
        Column,
        IconCross
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
        schema: {
            type: Object,
            required: true
        },
        canDelete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            values: { ...this.config }
        };
    },
    computed: {
        classes() {
            return [
                'build-config',
                {
                    'build-config--invalid': this.config.validated && !this.isValid
                }
            ];
        },
        $values() {
            const result = Object.keys(this.schema).map(field => {
                const { required = false } = this.schema[field];
                const { disabled = () => false } = this.schema[field];
                const { [field]: value = null } = this.values;

                return [
                    field,
                    {
                        invalid: required && !(Array.isArray(value) ? !!value.length : !!value),
                        disabled: this.loading || disabled(this.values)
                    }
                ];
            });

            return Object.fromEntries(new Map(result));
        },
        error() {
            return Object.keys(this.$values)
                .filter(k => this.$values[k].invalid)
                .reduce((acc, cur) => ({ ...acc, [cur]: [cur] }), {});
        },
        isValid() {
            return !Object.keys(this.error).length;
        }
    },
    watch: {
        values: {
            deep: true,
            immediate: true,
            handler(config) {
                this.$emit('update:config', { ...config, $valid: this.isValid });
            }
        }
    },
    methods: {
        deleteConfig() {
            const { id } = this.config;
            this.$emit('deleteConfig', { id });
        }
    }
};
</script>

<style lang="scss" src="./BuildConfig.scss"></style>
